import { makeStyles } from '@material-ui/core/styles';
import { colors } from 'UI/res';
import { ThemeModes } from 'UI/theme/themeMode';
import { flexAlignCenterJustifyCenter } from 'UI/utils/styles';

export const useStyles = makeStyles(
  theme => ({
    root: {
      width: 'fit-content',
      maxWidth: '100%',
      display: 'flex'
    },
    textContainer: {
      paddingRight: theme.spacing(4)
    },
    title: {
      fontWeight: theme.typography.fontWeightBold,
      lineHeight: '1.3em',
      height: 'auto',
      textTransform: 'capitalize'
    },
    body: {
      display: '-webkit-box',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      '-webkit-line-clamp': 2,
      '-webkit-box-orient': 'vertical',
      fontWeight: theme.typography.fontWeightLight,
      lineHeight: '1.3em',
      height: 'auto'
    },
    mutedBody: {
      color: theme.palette.text.secondary
    },
    indicator: {
      width: 8,
      height: 85,
      borderRadius: '4px 0px 0px 4px',
      position: 'absolute',
      color: ({ color }) => color
    },
    closeButton: {
      position: 'absolute',
      right: 5,
      top: 5
    },
    buttonContainer: {
      padding: 0
    }
  }),
  { classNamePrefix: 'snackBar' }
);

const snackbarRoot = {
  width: 500,
  maxWidth: '100%',
  ...flexAlignCenterJustifyCenter,
  borderRadius: '4px',
  margin: 0,
  fontSize: 16
};

/**
 * Dark mode "tonal" alert: tinted surface, subtle border and a severity accent bar, with regular
 * text colors. Light mode keeps MUI's filled alert.
 * @param {Object} theme
 * @param {'error'|'info'|'success'|'warning'} severity
 */
const tonalAlert = (theme, severity) => ({
  color: theme.palette.text.primary,
  backgroundColor: theme.palette[severity].FP100,
  border: `1px solid ${theme.palette[severity].FP200}`,
  borderLeft: `4px solid ${theme.palette[severity].main}`
});

export const useAlertStyles = makeStyles(theme => ({
  root: {
    ...snackbarRoot,
    padding: theme.spacing(2)
  },
  ...(theme.palette.type === ThemeModes.Dark && {
    filledError: tonalAlert(theme, 'error'),
    filledInfo: tonalAlert(theme, 'info'),
    filledSuccess: tonalAlert(theme, 'success'),
    filledWarning: tonalAlert(theme, 'warning')
  }),
  message: {
    flex: 1,
    padding: 0
  },
  icon: {
    ...flexAlignCenterJustifyCenter,
    alignSelf: 'baseline'
  }
}));

export const useNotificationStyles = makeStyles(
  theme => ({
    root: {
      ...snackbarRoot,
      padding: theme.spacing(2)
    },
    filledWarning: {
      backgroundColor: colors.white,
      color: colors.black
    },
    filledSuccess: {
      backgroundColor: colors.white,
      color: colors.black
    },
    message: {
      flex: 1
    },
    icon: {
      ...flexAlignCenterJustifyCenter
    }
  }),
  { classNamePrefix: 'notificationStyles' }
);
